import { listPhysicians } from './index';

import { physiciansRouteStore } from '../domain/store';

export default (e) => {
  physiciansRouteStore.setValue('filterValue', e.target.value);
  physiciansRouteStore.setValue('currentPage', 1);
  return listPhysicians();
};
